export default "__VITE_ASSET__b4243b34__"